import { LandingLayout } from 'layouts';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { ContentLeft, Footer, Header, type HeaderItem, OneTimeCodeCheck } from 'features/onboarding';
import { useOnSuccessLogin, useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';

export type LoginWithCodeLocationState = { tokenToGetCode?: string; tokenToLogin?: string } & OnboardingLocationState;

const PageLoginWithCode = () => {
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Location has any
  const state: LoginWithCodeLocationState | undefined = location.state;
  // eslint-disable-next-line @typescript-eslint/unbound-method -- Hook returns plain function from useMemo, that dont use this, false positive
  const { onNavigateToPrimaryLogin, onNavigateToSignUp } = useOnboardingNavigation<LoginWithCodeLocationState>();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- Hook returns plain function from useMemo, that dont use this, false positive
  const { onSuccessLogin } = useOnSuccessLogin<LoginWithCodeLocationState>();

  const headerButtons: HeaderItem[] = useMemo(
    () => [
      {
        label: 'Sign up',
        async onClick() {
          await onNavigateToSignUp();
        },
        type: 'primary',
      },
    ],
    [onNavigateToSignUp],
  );

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={
        <OneTimeCodeCheck<LoginWithCodeLocationState>
          onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
          onSuccessLogin={onSuccessLogin}
          state={state}
        />
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};

export default PageLoginWithCode;
